import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { MetaState, UserState } from "../../types/types";
import NoItems from "../alerts/NoItems";
import { Navigate, Outlet } from "react-router";

type Props = {
  allowedTo: string[];
};
const navigateTo: Record<string, string> = {
  admin: "/",
  superadmin: "/",
  accountant: "/orders",
  "account-manager": "/admin-settlements",
};
const AllowedTo = ({ allowedTo }: Props) => {
  const userData = useSelector((state: UserState) => state.user.userData);
  const { meta, loading: loadingMeta } = useSelector(
    (state: MetaState) => state.meta
  );

  const getRoleId = (roleName: string) => {
    for (let i in meta?.roles ?? {}) {
      if (meta?.roles[i] == roleName) {
        return i;
      }
    }
  };

  const allowedToRolesId = allowedTo.map((item) => getRoleId(item));

  const userRoles: number[] = userData.roles;

  const isAllowed = userRoles.some((role) =>
    allowedToRolesId.includes(role.toString())
  );

  return loadingMeta ? (
    <></>
  ) : isAllowed ? (
    <Outlet />
  ) : (
    <Navigate to={navigateTo[meta?.roles[userRoles[0] as any] as any]} />
  );

  // return loadingMeta ? (
  //   <></>
  // ) : isAllowed ? (
  //   <Outlet />
  // ) : userRoles.includes(Number(getRolesId("admin"))) ||
  //   userRoles.includes(Number(getRolesId("superadmin"))) ? (
  //   <Navigate to="/" />
  // ) : userRoles.includes(Number(getRolesId("accountant"))) ? (
  //   <Navigate to="/orders" />
  // ) : (
  //   <Navigate to="/not-found" />
  // );
};

export default AllowedTo;
